import HomePattern from "../HomePattern";

const Home = () => {

    return <HomePattern/>;
  };
  

export default Home;